import { Sheet, Table, Chip } from "@mui/joy";
import { SEdit, SDelete } from "../../../../styles/StyledMUI";
import { hrSheetSx, hrTableSx, hrAccentColor, textTokens } from "../../../../styles/globalStyles";
import DarkTypography from "../../../common/DarkTypography";
import DarkCard from "../../../common/DarkCard";
import IconButtonCTA from "../../../common/IconButtonCTA";
import type { Product } from "../../../../api/billing/Billing.typed";
import { formatPrice, htToTtc, DEFAULT_TAX_RATE } from "../../shared/billingUtils";

type Props = {
  groupName: string;
  items: Product[];
  canEdit: boolean;
  onEdit: (p: Product) => void;
  onDelete: (p: Product) => void;
};

export default function ProductGroupCard({ groupName, items, canEdit, onEdit, onDelete }: Props) {
  return (
    <DarkCard dense>
      <DarkTypography level="title-md" sx={{ mb: 0.5, color: hrAccentColor }}>
        {groupName || "Sans catégorie"}
        <DarkTypography
          component="span"
          level="body-sm"
          sx={{ color: textTokens.color.faint, ml: 1 }}
        >
          ({items.length} produit{items.length > 1 ? "s" : ""})
        </DarkTypography>
      </DarkTypography>
      <Sheet sx={hrSheetSx}>
        <Table hoverRow sx={hrTableSx}>
          <thead>
            <tr>
              <th>Nom</th>
              <th>Prix HT</th>
              <th>Prix TTC</th>
              <th>TVA</th>
              <th>Crédits</th>
              <th>Statut</th>
              {canEdit && <th style={{ width: 100 }}>Actions</th>}
            </tr>
          </thead>
          <tbody>
            {items.map((p) => (
              <tr key={p.ID}>
                <td>{p.Name}</td>
                <td>{formatPrice(p.Price, p.Currency)}</td>
                <td>{formatPrice(htToTtc(p.Price, p.TaxRate ?? DEFAULT_TAX_RATE), p.Currency)}</td>
                <td>{p.TaxRate ?? DEFAULT_TAX_RATE} %</td>
                <td>
                  {p.IsUnlimited ? (
                    <Chip size="sm" color="primary" variant="soft">
                      Illimité
                    </Chip>
                  ) : (
                    p.Credits
                  )}
                </td>
                <td>
                  <Chip size="sm" color={p.IsActive ? "success" : "neutral"} variant="soft">
                    {p.IsActive ? "Actif" : "Inactif"}
                  </Chip>
                </td>
                {canEdit && (
                  <td>
                    <IconButtonCTA aria-label="Modifier" size="sm" onClick={() => onEdit(p)}>
                      <SEdit />
                    </IconButtonCTA>
                    <IconButtonCTA
                      aria-label="Supprimer"
                      size="sm"
                      ctaVariant="danger"
                      onClick={() => onDelete(p)}
                    >
                      <SDelete />
                    </IconButtonCTA>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </Table>
      </Sheet>
    </DarkCard>
  );
}
